import { Form, Input, message } from 'antd';
import { ACTION_TITLE } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import { I18nFormFields } from '../../../../shared/components/i18n/I18nFormFields';
import { I18nFieldData } from '../../../../shared/types/i18n/i18nTypes';
import { genreService } from '../services/genreService';

const GenreAdd: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [i18nName, setI18nName] = useState<I18nFieldData>({});

  return (
    <Component.BasePageComponent>
      <div>
        <div className="people-details-page">
          <h1>Genre</h1>
          <Form form={form} layout="vertical" className="people-details-form">
            <I18nFormFields
              fieldName="name"
              required={true}
              fieldType="input"
              value={i18nName}
              onChange={value => setI18nName(value)}
              placeholder={{
                ko: 'Enter genre name',
                en: 'Enter genre name',
                'zh-hans': '请输入类型名称',
                'zh-hant': '請輸入類型名稱',
              }}
            />
            <Form.Item
              style={{ marginTop: '10px' }}
              name="slug"
              label="Slug"
              rules={[{ required: true, message: 'please enter slug' }]}
            >
              <Input onChange={e => (e.target.value = e.target.value.toLowerCase())} />
            </Form.Item>
          </Form>
        </div>
        <div className="people-detail-update-button">
          <Component.ColorButtonComponent
            text={ACTION_TITLE.ADD}
            onClick={async () => {
              const loadingMessage = message.loading('Creating...', 0);
              try {
                // Validate form first
                await form.validateFields();

                // Get current form values (slug only at this point)
                const formValues = form.getFieldsValue();

                // Prepare complete genre data with i18n fields
                const genreData = {
                  slug: formValues.slug || '',
                  i18n_name: i18nName || {},
                  // Legacy field: use ko value from i18n_name
                  name: i18nName?.ko?.toLowerCase() || '',
                };

                // Pass data directly to genreService
                await genreService.createGenre(form, genreData);
                loadingMessage();
                navigate('/genre');
              } catch (error) {
                loadingMessage();
                console.error('Error creating genre:', error);
              }
            }}
          />
        </div>
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(GenreAdd);
